import { ITypeCurveRisking } from '../../interfaces/itype-curve-risking';
import { Case } from '../case';
import { TypeCurve } from '../type-curve';

export class TypeCurveRiskingBase {
  TypeCurveRiskingId: number;
  TypeCurveId: number;
  CaseId: number;
  Geo: number | null;
  Oil: number | null;
  Gas: number | null;
  Water: number | null;
  UpdatedBy: string;
  Created: Date;
  Updated: Date;
  CreatedBy: string;

  Case?: Case;
  TypeCurve?: TypeCurve;

  constructor(item?: ITypeCurveRisking) {
    if (item) {

      this.TypeCurveRiskingId = item.TypeCurveRiskingId;
      this.TypeCurveId = item.TypeCurveId;
      this.CaseId = item.CaseId;
      this.Geo = item.Geo;
      this.Oil = item.Oil;
      this.Gas = item.Gas;
      this.Water = item.Water;
      this.UpdatedBy = item.UpdatedBy;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.CreatedBy = item.CreatedBy;

      this.Case = new Case(item.Case);
      this.TypeCurve = new TypeCurve(item.TypeCurve);
    }
  }
}